export default "__VITE_ASSET__CJvojcNv__"